import { cryptoDepositAddressActionTypes } from "../../../action-types";

const cryptoDepositAddress = JSON.parse(localStorage.getItem("cryptoDepositAddress"));

const initialState = {
  cryptoDepositAddress: cryptoDepositAddress ? cryptoDepositAddress : null
};

export default function cryptoDepositAddressReducer(state = initialState, action) {
  switch (action.type) {
    case cryptoDepositAddressActionTypes.ADD_CLIENT_CRYOTO_ACCOUNTS_DEPOSIT_ADDRESSES:
      return {
        cryptoDepositAddress: action.payload,
      };
    default:
      return state;
  }
}
